import { createAsyncThunk } from '@reduxjs/toolkit';
import pageIndicatorsApi from '../../../api/pageIndicatorsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'pageIndicators';

export const GetPageIndicators = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/getPageIndicators`,
  async (params, thunkAPI) => {
    const res = await pageIndicatorsApi.get(params);

    if (res?.status === 200) {
      return res.data.data.list;
    }

    return thunkAPI.rejectWithValue(null);
  }
);
